<template>
  <div>
    <el-table
      :data="widget.options.tableData"
      :style="{ width: widget.options.width }"
      border
    >
      <el-table-column
        v-for="(item, index) in widget.options.tableTitle"
        :key="index"
        :prop="item.prop"
        :label="item.label"
      ></el-table-column>
    </el-table>
    <el-pagination
      style="margin-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="widget.options.total"
    ></el-pagination>
  </div>
</template>

<script>
import bus from '../../../util/eventBus'
import generateUtils from '../../../util/generateUtils'
import formUtils from '../../../util/formUtils'
export default {
  // 级联选择框
  name: 'sw-table',
  props: ['widget', 'cascader', 'config', 'disabled'],
  data() {
    return {
      pageSize: 5,
      pageNum: 1,
    }
  },
  created() {},
  mounted() {
    this.getRemoteData()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getRemoteData()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getRemoteData()
    },
    // 自定义事件触发
    eventMethod() {
      bus.$emit('eventMethod', this.widget)
    },
    getQueryParams() {
      // 约定不定值参数数组
      const arr = this.widget.options.variables || []
      const params = []
      arr.forEach(item => {
        const value = formUtils.getQueryVariable(item.name)
        if (value) {
          params.push({ [item.name]: value })
        }
      })
      params.push({ [this.widget.options.props.page]: this.pageNum })
      params.push({ [this.widget.options.props.pageSize]: this.pageSize })
      return params
    },
    getRemoteData() {
      const queryParams = this.getQueryParams()
      // 获取表格数据
      generateUtils.queryRemoteTableData(this.widget, queryParams)
    },
  },
  watch: {
    casValue: {
      handler(val) {
        this.$emit('update:cascader', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
